<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<form [formGroup]="formGroup">
  <mat-form-field class="input" appearance="fill">
    <mat-label> Title </mat-label>
    <input
      matInput
      [formControlName]="titleControlKey"
      placeholder="Ex. Regenerative agriculture survey"
    />
  </mat-form-field>

  <mat-form-field class="input" appearance="fill">
    <mat-label> Description </mat-label>
    <input
      matInput
      [formControlName]="descriptionControlKey"
      placeholder="Ex. Self-reporting of community-led regenerative agriculture activities"
    />
  </mat-form-field>
</form>
